import React from "react";

// ──────────────────────────────────────────────────────
// FontSizeModal.jsx — 글자 크기(접근성) 선택 시트
//   작게(0.9) / 보통(1.0, 기본) / 크게(1.15) 3단계. 선택 즉시 미리보기(App 의 zoom 적용).
//   malso 앱의 "글자 크기" 시트와 동일한 톤(흰 카드 + 라운드 + 하단 확인 버튼).
// ──────────────────────────────────────────────────────

const OPTIONS = [
  { scale: 0.9, label: "작게", sample: 22 },
  { scale: 1.0, label: "보통", sample: 30 },
  { scale: 1.15, label: "크게", sample: 40 },
];

const FontSizeModal = ({ open, value, onSelect, onClose }) => {
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(15,18,28,0.45)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        // 시트는 하단 정렬(바텀시트). 데스크톱에서도 자연스럽게 보이도록 좌우 여백.
        padding: 16,
        boxSizing: "border-box",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 460,
          background: "#ffffff",
          borderRadius: 22,
          padding: "22px 20px 20px",
          boxShadow: "0 -8px 40px rgba(15,20,40,0.22)",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: 18,
            fontWeight: 700,
            color: "#1a1b1e",
            marginBottom: 18,
          }}
        >
          글자 크기
        </div>

        {/* 3 카드 — 작게 / 보통 / 크게 */}
        <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
          {OPTIONS.map((opt) => {
            const selected = value === opt.scale;
            return (
              <button
                key={opt.label}
                onClick={() => onSelect(opt.scale)}
                style={{
                  flex: 1,
                  background: "#fff",
                  border: selected
                    ? "2px solid #18181b"
                    : "1.5px solid #e5e7eb",
                  borderRadius: 16,
                  padding: "22px 6px 14px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  transition: "border-color 0.15s, box-shadow 0.15s",
                  boxShadow: selected
                    ? "0 2px 10px rgba(20,30,60,0.08)"
                    : "none",
                }}
                aria-pressed={selected}
              >
                <span
                  style={{
                    fontSize: opt.sample,
                    fontWeight: 700,
                    lineHeight: 1,
                    color: "#1a1b1e",
                  }}
                >
                  가
                </span>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: selected ? 700 : 500,
                    color: selected ? "#18181b" : "#6b7280",
                  }}
                >
                  {opt.label}
                </span>
              </button>
            );
          })}
        </div>

        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: "15px",
            border: "none",
            borderRadius: 14,
            background: "#18181b",
            color: "#fff",
            fontSize: 16,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default FontSizeModal;
